import { render, staticRenderFns } from "./LanguageSwitch.vue?vue&type=template&id=31dc342b&scoped=true"
import script from "./LanguageSwitch.vue?vue&type=script&lang=js"
export * from "./LanguageSwitch.vue?vue&type=script&lang=js"
import style0 from "./LanguageSwitch.vue?vue&type=style&index=0&id=31dc342b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dc342b",
  null
  
)

export default component.exports